// extracted by mini-css-extract-plugin
export default {"search":"queue_search__z5YEO"};